import { useEffect } from 'react'

const NiadaRedirect = () => {
  useEffect(() => {
    window.location.href =
      'https://forms.office.com/Pages/ResponsePage.aspx?id=5Ecx0le05Uu5U-cf5pmS-K63ls4euIhIolRWyuFilpNUM0xPU1pMVUdYVTZVNjI1OVBOSVA4WEYySy4u'
  }, [])

  return null
}

export default NiadaRedirect
